import TabNav from "common/components/TabNav"
import AlbaranesEnviados from "features/Documentos/pages/Albaranes/AlbaranesEnviados"
import AlbaranesRecibidos from "features/Documentos/pages/Albaranes/AlbaranesRecibidos"
import { useSelector } from "hooks/useSelector"
import { nanoid } from "nanoid"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { TAB_DOCUMENTOS_RECIBIDOS } from "../../constants"
import { albaranesColumns } from "../../constants/albaranesColumns"
import DocumentoColumnsProvider from "../../context/DocumentoColumnsContext"
import { documentosSelector } from "../../redux/documentosSlice"

const TABS = (t: $TSMigrationFixMe) => [
  {
    key: nanoid(),
    header: `${t("crear.albaran.saleLabel")}`,
    component: AlbaranesEnviados,
    id: 0,
  },
  {
    key: TAB_DOCUMENTOS_RECIBIDOS,
    header: `${t("crear.albaran.buyLabel")}`,
    component: AlbaranesRecibidos,
    id: 1,
  },
]

const Albaran = () => {
  const { t } = useTranslation()
  const [tabSelected, setTabSelected] = useState(0)
  const [tabs, setTabs] = useState(TABS(t))
  const { documentosPendientes } = useSelector(documentosSelector)

  useEffect(() => {
    setTabs(TABS(t))
  }, [t])

  useEffect(() => {
    setTabs((prevTabs) =>
      prevTabs.map((tab) =>
        tab.key === TAB_DOCUMENTOS_RECIBIDOS
          ? {
              ...tab,
              quantity: documentosPendientes,
            }
          : tab
      )
    )
  }, [documentosPendientes])

  return (
    <DocumentoColumnsProvider columns={albaranesColumns(tabSelected, t)}>
      <div className='tw-bg-white tw-rounded-xl tw-min-w-fit tw-shadow !tw-h-full tw-overflow-hidden'>
        <div className='tw-py-4 tw-px-8 mobile:tw-flex tw-justify-between tw-flex-col tw-items-start sm:tw-items-center sm:tw-flex-row tw-hidden'>
          <TabNav
            tabs={tabs}
            active={tabSelected}
            setActive={setTabSelected}
          />
        </div>
        {TABS(t).map((tab) => (
          <>{tab.id === tabSelected && <tab.component />}</>
        ))}
      </div>
    </DocumentoColumnsProvider>
  )
}

export default Albaran
